import { useState } from 'react';

import { TabsContent } from '@repo/videa-components/src/ui/tabs';
import classNames from 'classnames';

import { useImageFallback } from '@/utils/hooks';

import type { AdultTreatmentKey } from './AdultTabs';
import type { PediatricTreatmentKey } from './PediatricTabs';

interface Props {
  fallback: string;
  src: string;
  tabKey: AdultTreatmentKey | PediatricTreatmentKey;
  isVideo?: boolean;
}

export const TreatmentTabContent = ({
  fallback,
  src,
  tabKey,
  isVideo = false,
}: Props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { imgSrc, onError } = useImageFallback(src, fallback);

  return (
    <TabsContent key={tabKey} value={tabKey}>
      <div
        className="vai-flex vai-justify-center vai-items-center vai-h-[500px] vai-w-full vai-max-w-full vai-min-w-0 vai-overflow-hidden"
        data-testid={`tab-content-${tabKey}`}
      >
        {isVideo ? (
          <video
            autoPlay
            loop
            muted
            playsInline
            className={classNames(
              'vai-max-h-[500px] vai-max-w-full vai-object-contain vai-transition-opacity vai-duration-300',
              {
                'vai-opacity-100': isLoaded,
                'vai-opacity-0': !isLoaded,
              },
            )}
            onLoadedData={() => setIsLoaded(true)}
            onError={onError}
          >
            <source src={imgSrc} type="video/mp4" />
            <source src={fallback} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          /* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */
          <img
            alt={tabKey}
            className={classNames(
              'vai-max-h-[500px] vai-max-w-full vai-object-contain vai-transition-opacity vai-duration-300',
              {
                'vai-opacity-100': isLoaded,
                'vai-opacity-0': !isLoaded,
              },
            )}
            onLoad={() => setIsLoaded(true)}
            onError={onError}
            src={imgSrc}
          />
        )}
      </div>
    </TabsContent>
  );
};
